import { createContext } from "react"

const AccessAreaContext = createContext();

export default AccessAreaContext;